import { getTumblerConfig } from '../../../utils/appConfig';

/**
 * Partitions Piezo stays out of. Substring-matched, so every `aws-iso*` variant is covered by one entry.
 *
 * The isolated and sovereign partitions cannot sign at all: index.tsx returns before Piezo init for them.
 * GovCloud runs the page normally and is held back by this gate alone, having no Piezo daemon.
 */
export const PIEZO_DISABLED_PARTITIONS: readonly string[] = ['gov', 'iso', 'eusc'];

/**
 * Mirrored by server/utils/tumbler/toolMigration.ts and pinned to it by test: a side that signs where the
 * other does not expect an artifact fails the operation rather than degrading it.
 *
 * Case-insensitive, because CDK-injected config is not normalized. Fails closed on any other stage.
 */
export function isPiezoEnabledFor(stage?: string, partition?: string): boolean {
  const lowerPartition = (partition ?? '').toLowerCase();
  if (PIEZO_DISABLED_PARTITIONS.some((excluded) => lowerPartition.includes(excluded))) {
    return false;
  }
  switch ((stage ?? '').toLowerCase()) {
    case 'beta':
    case 'gamma':
    case 'prod':
      return true;
    default:
      return false;
  }
}

/** Reads the config itself so no call site can gate on a different source of truth. */
export function isPiezoEnabledEnvironment(): boolean {
  const config = getTumblerConfig();
  return isPiezoEnabledFor(config?.stage, config?.current?.partition);
}
